// IndemnityAnimation.js
import React from "react";
import Lottie from "react-lottie";
import indemnityAnimation from "./animations/indemnity.json"; // Adjust the path as needed

const IndemnityAnimation = () => {
  const defaultOptions = {
    loop: true, // The animation will replay continuously
    autoplay: true,
    animationData: indemnityAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Lottie options={defaultOptions} height={400} width={400} />
    </div>
  );
};

export default IndemnityAnimation;
